// Mock data for Stefen's Mobile Detailing

export const businessInfo = {
  name: "Stefen's Mobile Detailing",
  phone: "(505) 595-9416",
  bookingUrl: "https://stefensdetailing.square.site",
  serviceArea: "Albuquerque & Los Lunas"
};

export const services = [
  {
    id: 0,
    name: "Ceramic Coating Special",
    bookingName: "$999 Ceramic coating special",
    price: "$999",
    description: "Multi-year paint protection with professional-grade graphene ceramic coating. Deep gloss, hydrophobic water-beading and UV defense, all with a mirror-like finish. Comes with a 1-step paint correction.",
    image: "/images/service-ceramic.jpg",
    beforeImage: "/images/ceramic-before.jpg?v=2",
    afterImage: "/images/ceramic-after.jpg?v=2",
    featured: true
  },
  {
    id: 1,
    name: "Interior Detailing",
    description: "Deep cleaning, conditioning, and protection for every interior surface",
    image: "https://images.unsplash.com/photo-1547306220-c0ab7aba52b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjYXIlMjBzdGVlcmluZyUyMHdoZWVsfGVufDB8fHx8MTc3NTkzMDQ5NHww&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=LTHY3R7ZNZXKSTTRZOD3VPVB"
  },
  {
    id: 2,
    name: "Exterior Wash",
    description: "Premium hand wash, clay bar treatment, and protective wax application",
    image: "https://images.unsplash.com/photo-1770700391793-22fc46041c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXIlMjBleHRlcmlvciUyMHdhc2glMjBzcGFya2xlJTIwY2xlYW58ZW58MHx8fHwxNzc1OTMwNTM2fDA&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=J6VJEWRE2WZO6HDAQ64OSVNY"
  },
  {
    id: 3,
    name: "Full Detail",
    description: "Complete interior and exterior transformation for ultimate results",
    image: "https://images.unsplash.com/photo-1647844834614-a62f2eb8f16c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHx0aHVtYnMlMjB1cCUyMGNhciUyMGRldGFpbGluZ3xlbnwwfHx8fDE3NzU5MzA1NDB8MA&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=OV5WH2UH5VSNZXQMAANXVUOT"
  },
  {
    id: 4,
    name: "Paint Correction",
    description: "Multi-step machine polishing to eliminate swirls and scratches",
    image: "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxjYXIlMjBwb2xpc2hlciUyMG1hY2hpbmUlMjBkZXRhaWxpbmd8ZW58MHx8fHwxNzc1OTMwNTM4fDA&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=HBQ576AAI3LN7KGW2AKZ2SE7"
  },
  {
    id: 5,
    name: "Ceramic Coating",
    description: "Professional-grade protection with years of durability and shine",
    image: "/images/service-ceramic.jpg",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=TYHEAIT4GJSTY24L5PHQFDGB"
  },
  {
    id: 6,
    name: "RV Wash & Wax",
    description: "Specialized cleaning and protection for recreational vehicles",
    image: "/images/service-rv.jpg",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=YVLJKB3VTPZXWB4ZRF7D6LKY"
  },
  {
    id: 7,
    name: "Headlight Restoration",
    description: "Remove oxidation and restore clarity for improved safety and appearance",
    image: "https://images.unsplash.com/photo-1542367833-af617d047451?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxjYXIlMjBoZWFkbGlnaHQlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc3NTkzMDUzOXww&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=6ZIISEC3CCKP3N5XMPOWXW2F"
  },
  {
    id: 8,
    name: "Engine Bay Cleaning",
    description: "Professional degreasing and detailing under the hood",
    image: "https://images.unsplash.com/photo-1752774579270-523a9e91e6d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjBiYXklMjBjbGVhbnxlbnwwfHx8fDE3NzU5MzA1Mzh8MA&ixlib=rb-4.1.0&q=85",
    bookingUrl: "https://book.squareup.com/appointments/rv9jgibgg43s8x/location/LH2NQG6SR97VW?buttonTextColor=ffffff&color=0019ff&locale=en&referrer=so&service_id=7GSDGUQOMD63MP67VVUWHPXU"
  }
];

export const trustBadges = [
  { id: 1, text: "We Come to You", subtext: "Fully mobile setup", image: "/images/badge-mobile.jpg" },
  { id: 2, text: "Over {count} Vehicles Detailed", count: 300, subtext: "Happy local drivers", image: "/images/badge-vehicles.jpg" },
  { id: 3, text: "Albuquerque Local", subtext: "Proudly New Mexican", image: "/images/badge-local.jpg" },
  { id: 4, text: "Fully Insured", subtext: "Your vehicle is protected", image: "/images/badge-insured.jpg" }
];

export const heroImage = "/images/hero-porsche-718.jpg";

export const serviceCities = [
  { name: "Albuquerque", lat: 35.0844, lng: -106.6504 },
  { name: "Rio Rancho", lat: 35.2328, lng: -106.663 },
  { name: "Corrales", lat: 35.2378, lng: -106.6067 },
  { name: "Bernalillo", lat: 35.3, lng: -106.5511 },
  { name: "Los Ranchos", lat: 35.162, lng: -106.6425 },
  { name: "Tijeras", lat: 35.0887, lng: -106.3864 },
  { name: "Los Lunas", lat: 34.8062, lng: -106.7334 },
  { name: "Belen", lat: 34.6628, lng: -106.7764 },
  { name: "Bosque Farms", lat: 34.8548, lng: -106.7053 },
  { name: "Peralta", lat: 34.837, lng: -106.6906 }
];
